
export class IsiXmlDataResult {

    public val: string;
    public result: string;
    public txt: string;
    public hasTxt: boolean;
    public ctrl: IwsControle;
    public type: string;
    public extendedMode: boolean;

    constructor(val: any, result: string, ctrl: IwsControle, type: string) {
        this.val = val;
        this.result = result;
        this.txt = "";
        this.hasTxt = false;
        this.ctrl = ctrl;
        this.type = type;
    }


}
